export enum ActivityInitiator {
  Corporate = 'Corporate',
  Consumer = 'Consumer',
  Provider = 'Provider'
}
